module.exports = __webpack_public_path__ + "static/img/8029_phase_function_Paper_Points.9ce8a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8029_phase_function_Paper_Points.png
// module id = kpY4
// module chunks = 0